import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useQuery, gql, useMutation } from "@apollo/client";
// import { ToastContainer, toast } from "react-toastify";
import toast from "react-hot-toast";
import { Formik } from "formik";
import { useNavigate, useLocation, useParams } from "react-router-dom";

import { appContext } from "../../../context/ContextProvider";
import PreAuthAddDiagnoseModal from "./PreAuthAddDiagnoseModal";
import PreAuthSupportingInfo from "./PreAuthSupportingInfo";
import PreAuthActivityModal from "./PreAuthActivityModal";
import PreAuthAddPackages from "./PreAuthAddPackages";
import SupportingInfoForm from "./SupportingInfoForm";
import PreAuthInfo from "./request/PreAuthInfo";
import BeneficiaryInfo from "./request/BeneficiaryInfo";
import CareTeam from "./request/CareTeam";
import Diagnosis from "./request/Diagnosis";
import IsAccident from "./request/IsAccident";
import ItemsList from "./request/ItemsList";
import preAuth from "../../../gql/preAuth";
import AppErrorAlert from "../../../components/AppErrorAlert";
import { useContext } from "react";
import VisionPrescription from "./request/VisionPrescription";
import supportingInfoElements from "./request/SupportingInfoElement";
import {
  withReferralInSupportingInfo,
} from "../../../utils/referralSupportingInfo";
import EncounterForm from "./request/EncounterForm";
import AppLoader from "../../../components/AppLoader";
import PreAuthResponseModal from "./PreAuthResponseModal";
import { preAuthValidationSchema } from "./request/ValidationSchema";

import "../styles/pre-auth.css";
import "../../Beneficiary/styles/BeneficiaryList.css";
import AppModal from "../../../components/AppModal";
import { Button } from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import { useTranslation } from "react-i18next";
import BeneficiaryFormSkeleton from "../../../common/BeneficiaryFormSkeleton";
import CustomButton from "../../../shared/CustomButton";
import ValidationErrors from "../../../components/ValidationErrors";

function PreAuthForm(props) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  // const followUpItem = location.state?.item ? location.state.item : null;
  const currentDate = new Date();

  const [item, setItem] = useState(null);
  const [isFollowUp, setIsFollowUp] = useState(false);
  const { id, followUp } = useParams();

  const { showErrorAlert, setShowErrorAlert } = useContext(appContext);
  const isEditRef = React.useRef(false);
  const prevTransIdRef = React.useRef("");
  const [errorData, setErrorData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [showPreAuthResponseModal, setShowPreAuthResponseModal] =
    useState(false);
  const [currentTransactionIdItem, setCurrentTransactionIdItem] =
    useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const formikRef = React.useRef();

  useEffect(() => {
    if (selectedPatient) {
      isEditRef.current = false;
      prevTransIdRef.current = "";
      if (formikRef.current) {
        formikRef.current.setFieldValue("is_edit_request", false);
        formikRef.current.setFieldValue("prv_transaction_id", "");
      }
    }
  }, [selectedPatient]);
  const {
    loading: loadingDetails,
    error: detailsError,
    data: detailsData,
    refetch: refetchDetails,
  } = useQuery(preAuth.GET_PREAUTH_TRANSACTION_DETAILS, {
    variables: {
      transactionId: id,
    },
    fetchPolicy: "no-cache",
    skip: !id,
  });

  useEffect(() => {
    if (id) {
      refetchDetails();
    }
  }, []);

  useEffect(() => {
    if (detailsData?.getPreAuthTransaction?.data) {
      // setTimeout(() => {
      setItem(detailsData?.getPreAuthTransaction?.data);
      if (followUp == "follow-up") {
        setIsFollowUp(true);
      } else {
        setIsFollowUp(false);
      }
      // }, 500);
    }
  }, [detailsData]);

  // useEffect(() => {
  //   if (followUpItem) {
  //     setIsFollowUp(true);
  //     setItem(followUpItem);
  //   } else {
  //     setIsFollowUp(false);
  //     setItem(null);
  //   }
  // }, [followUpItem]);

  const [requestPreAuth, { data, loading, error }] = useMutation(
    preAuth.REQUEST_AUTHORIZATION,
    {
      update(proxy, result) {
        onSuccessfulRequestResponse(result.data);
      },
      onError(error) {
        onResponseError(error.graphQLErrors[0]);
      },
    },
  );

  const onSuccessfulRequestResponse = (data) => {
    setShowLoader(false);
    if (data.preAuthRequest.transaction_id && !data.preAuthRequest.nphies_err?.length) {
      toast.success("Successfully Requested!");
      setCurrentTransactionIdItem({
        transaction_id: data.preAuthRequest.transaction_id,
      });
      isEditRef.current = false;
      prevTransIdRef.current = "";

      // setShowPreAuthResponseModal(true);
      navigate("/preauth", { replace: true });
      return;
    } else if (data.preAuthRequest.nphies_err) {
      if (data.preAuthRequest.transaction_id) {
        isEditRef.current = true;
        prevTransIdRef.current = data.preAuthRequest.transaction_id;
      }
      setErrorData(data.preAuthRequest.nphies_err);
      setShowErrorAlert(true);
    } else {
      toast.error(`Please Add Values, Validation Error`);
    }
  };

  const onResponseError = (error) => {
    setShowLoader(false);

    if (error) {
      toast.error(`${error.message}`);
    } else {
      toast.error(`Please Add Values, Validation Error`);
    }
  };

  const stringToBoolean = (stringVal) => {
    if (String(stringVal).toLowerCase() == "true") {
      return true;
    } else {
      return false;
    }
  };

  const formatInputData = (postData) => {
    // if a previous request returned validation errors with a transaction_id,
    // override to use the edit API with that stored transaction id
    const effectiveIsEdit = isEditRef.current || postData?.is_edit_request;
    const effectivePrvTransId = prevTransIdRef.current || postData?.prv_transaction_id;

    const supportingInfos = postData.isReferralIn
      ? withReferralInSupportingInfo(postData.supportingInfos)
      : postData.supportingInfos;

    return {
      // is_communication_req: false,
      is_edit_request: effectiveIsEdit,
      ref_transaction_id: postData?.refTransactionId,
      is_followup_req: postData?.isFollowUpReq,
      prv_transaction_id: effectivePrvTransId,

      // payer_id: postData?.payerId,
      patient_id: postData.patientId,
      insurance_plan_id: postData.insurancePlanId,
      is_new_born: postData.isNewBorn,
      is_referral: postData.isReferral,
      is_referral_in: postData.isReferralIn,
      date_ordered: postData.dateOrdered,
      priority: postData.priority,
      pre_auth_ref_no:
        postData.preAuthRefNo != "" ? postData.preAuthRefNo : null,
      offline_pre_auth_no:
        postData.offlinePreAuthNo != "" ? postData.offlinePreAuthNo : null,
      offline_pre_auth_date:
        postData.preAuthRefNo != "" || postData.offlinePreAuthNo != ""
          ? postData.offlinePreAuthDate || postData.dateOrdered
          : null,
      type: postData.claimType,
      subtype: postData.subType,
      offline_verification_id:
        postData.offlineEligibilityId != ""
          ? postData.offlineEligibilityId
          : null,
      offline_verification_date:
        postData.offlineEligibilityDate != ""
          ? postData.offlineEligibilityDate
          : null,
      verification_resp_ident_value:
        postData.eligibilityResponseIdentifierValue != ""
          ? postData.eligibilityResponseIdentifierValue
          : null,

      verification_resp_ident_url:
        postData.eligibilityResponseIdentifierUrl != ""
          ? postData.eligibilityResponseIdentifierUrl
          : null,

      // referrring_provider: postData.referringProvider,
      physicians_id: [
        postData.careTeamsArr.length > 0
          ? postData.careTeamsArr[0].practitioner
          : 0,
      ],
      diagnosis: postData.diagnosisArr.map((item) => {
        return {
          type: item.type,
          on_admission: stringToBoolean(item.on_admission),
          code: item.codeId,
          description: item.codeDescription,
          condition_on_set: item?.condition_on_set,
        };
      }),
      supporting_info: supportingInfos?.map((item) => {
        const hasImageFields = 
          ("fileName" in item && item?.fileName) || 
          ("attachment" in item && item?.attachment) || 
          ("imageMinioPath" in item && item?.imageMinioPath);
        
        return {
          category: "category" in item ? item.category : null,
          code: "code" in item ? item.code : null,
          code_text: "codeText" in item ? item.codeText : null,
          start_date:
            "startDate" in item ? item.startDate || postData.dateOrdered : null,
          end_date:
            "endDate" in item ? item.endDate || postData.dateOrdered : null,
          value: "value" in item ? (item.value ?? (item.reason ? "" : null)) : (item.reason ? "" : null),
          unit:
            "valueUnit" in item && item.valueUnit != "" ? item.valueUnit : null,
          reason: "reason" in item ? item.reason : null,
          image_content_type: hasImageFields && item?.fileType ? item.fileType : null,
          image_title: hasImageFields && item?.fileName ? item.fileName : null,
          image_creation_date: hasImageFields && (item?.attachment || item?.imageMinioPath) ? new Date() : null,
          image_value: hasImageFields && item?.attachment && !item?.imageMinioPath ? item.attachment : null,
          image_minio_path: hasImageFields && item?.imageMinioPath ? item.imageMinioPath : null,
        };
      }),
      is_accident: postData.is_accident,
      accident_info: {
        type: postData.accidentType,
        street_name: postData.street,
        city: postData.city,
        state: postData.state,
        country: postData.country,
        date: postData.date,
      },
      items: postData.items.map((item) => {
        return {
          type: item.type,
          standard_code: item.standardCode,
          standard_description: item.standardCodeDescription,
          non_standard_code:
            item.non_standard_code != "" ? item.non_standard_code : null,
          non_standard_description:
            item.non_standard_description != ""
              ? item.non_standard_description
              : null,
          medication_selection_reason:
            item.medicationSelectionReason != ""
              ? item.medicationSelectionReason
              : null,
          prescribed_medication:
            item.prescribedMedication != "" ? item.prescribedMedication : null,
          body_site: item.body_site != "" ? item.body_site : null,
          sub_site: item.sub_site,
          maternity: item?.maternity,
          service_start_date: item.service_start_date,
          service_end_date: item.service_end_date,
          supporting_info: item.supporting_info.map((value) =>
            parseInt(value, 10),
          ),
          diagnosis: item.diagnosis.map((value) => parseInt(value, 10)),
          care_teams: item.care_teams.map((value) => parseInt(value, 10)),
          is_package: stringToBoolean(item.is_package),
          quantity: parseInt(item.quantity ? item.quantity : "0"),
          code: item.prescribedMedication ? item.prescribedMedication : "", //pending
          unit_price: parseFloat(item.unit_price ? item.unit_price : "0"),
          tax_amount: parseFloat(item.tax_amount ? item.tax_amount : 0),
          factor: parseFloat(item.factor ? item.factor : 0),
          net: parseFloat(item.net ? item.net : 0),
          discount_amount: parseFloat(
            item.discount_amount ? item.discount_amount : 0,
          ),
          patient_share: parseFloat(
            item.patient_share ? item.patient_share : 0,
          ),
          patient_share_amount: parseFloat(
            item.patientShareAmount ? item.patientShareAmount : 0,
          ),
          payer_share: parseFloat(item.payer_share ? item.payer_share : 0),
        };
      }),
      vision_prescription: postData.isVisionPrescription
        ? {
          date_written: postData.visionPrescriptionDateWritten,
          prescriber_id: postData.prescriber_id,
          lens_specifications: postData.lens_specifications.map((item) => {
            return {
              product: item?.product,
              color: item?.color,
              brand: item?.brand,
              notes: item?.notes != "" ? item?.notes : null,
              right: {
                eye_name: "right",
                sphere:
                  item?.rightSphere != ""
                    ? parseFloat(item?.rightSphere)
                    : null,
                cylinder:
                  item?.rightCylinder != ""
                    ? parseFloat(item?.rightCylinder)
                    : null,
                axis: item?.rightAxis != "" ? item?.rightAxis : null,
                add: item?.rightAdd != "" ? parseFloat(item?.rightAdd) : null,
                prism: {
                  base:
                    item?.rightPrismUnit != "" ? item?.rightPrismUnit : null,
                  amount:
                    item?.rightPrismVal != ""
                      ? parseFloat(item?.rightPrismVal)
                      : null,
                },
                power:
                  item?.rightPowerContact != ""
                    ? parseFloat(item?.rightPowerContact)
                    : null,
                back_curve:
                  item?.rightBackCurveContact != ""
                    ? parseFloat(item?.rightBackCurveContact)
                    : null,
                diameter:
                  item?.rightDiameterContact != ""
                    ? parseFloat(item?.rightDiameterContact)
                    : null,
                duration: {
                  time:
                    item?.rightUnitContact != ""
                      ? item?.rightUnitContact
                      : null,
                  value:
                    item?.rightDurationContact != ""
                      ? item?.rightDurationContact
                      : null,
                },
              },
              left: {
                eye_name: "left",
                sphere:
                  item?.leftSphere != ""
                    ? parseFloat(item?.leftSphere)
                    : null,
                cylinder:
                  item?.leftCylinder != ""
                    ? parseFloat(item?.leftCylinder)
                    : null,
                axis: item?.leftAxis != "" ? item?.leftAxis : null,
                add: item?.leftAdd != "" ? parseFloat(item?.leftAdd) : null,
                prism: {
                  base:
                    item?.leftPrismUnit != "" ? item?.leftPrismUnit : null,
                  amount:
                    item?.leftPrismVal != ""
                      ? parseFloat(item?.leftPrismVal)
                      : null,
                },
                power:
                  item?.leftPowerContact != ""
                    ? parseFloat(item?.leftPowerContact)
                    : null,
                back_curve:
                  item?.leftBackCurveContact != ""
                    ? parseFloat(item?.leftBackCurveContact)
                    : null,
                diameter:
                  item?.leftDiameterContact != ""
                    ? parseFloat(item?.leftDiameterContact)
                    : null,
                duration: {
                  time:
                    item?.leftUnitContact != ""
                      ? item?.leftUnitContact
                      : null,
                  value:
                    item?.leftDurationContact != ""
                      ? item?.leftDurationContact
                      : null,
                },
              },
            };
          }),
        }
        : null,
      is_vision_prescription: postData.isVisionPrescription,
      encounter: postData.isEncounter
        ? {
          class: postData.encounterClass,
          status: postData.encounterStatus,
          service_type: postData.serviceType,
          service_event_type: postData.serviceEventType,
          priority: postData.encounterPriority,
          period_start: postData.periodStart,
          period_end: postData.periodEnd,
          admin_source: postData.adminSource,
          readmission: postData.readmission,
          discharge_disposition: postData.dischargeDisposition,
          emr_arrival_code: postData.emergencyArivalCode,
          emr_service_start: postData.emergencyServiceDate,
          emr_dept_disp: postData.emergencyDepartmentDisposition,
          triage_category: postData.triageCategory,
          triage_date: postData.triageDate,
          hosp_adm_speciality: postData.admissionSpeciality,
          hosp_discharge_speciality: postData.dischargeSpeciality,
          intended_length_of_stay: postData.intendedLengthOfStay,
        }
        : null,
    };
  };

  function snakeToCamel(obj) {
    if (obj === null || typeof obj !== "object") {
      return obj;
    }

    if (Array.isArray(obj)) {
      return obj.map((item) => snakeToCamel(item));
    }

    return Object.keys(obj).reduce((acc, key) => {
      const camelKey = key.replace(/_([a-z])/g, (match, letter) =>
        letter.toUpperCase(),
      );
      acc[camelKey] = snakeToCamel(obj[key]);
      return acc;
    }, {});
  }

  const setSupportingInfo = (object) => {
    let obj = snakeToCamel(object);
    let x = obj;
    
    const imageFields = {
      fileName: obj.fileName,
      fileType: obj.fileType,
      attachment: obj.attachment,
      imageMinioPath: obj.imageMinioPath,
      imageUrl: obj.imageUrl,
    };
    
    supportingInfoElements(t).map((item, key) => {
      if (item.object.category == obj?.category) {
        const obj1Keys = Object.keys(item.object);
        const obj2Keys = Object.keys(obj);

        const keysToRemove = obj2Keys.filter((key) => !obj1Keys.includes(key));

        keysToRemove.forEach((key) => delete obj[key]);

        x = obj;
      }
    });

    if (x.category === "attachment" || x.category === "investigation-result" || "attachment" in x) {
      x.fileName = imageFields.fileName;
      x.fileType = imageFields.fileType;
      x.attachment = imageFields.attachment;
      x.imageMinioPath = imageFields.imageMinioPath;
      x.imageUrl = imageFields.imageUrl;
    }

    return x;
  };

  const initialValues = {
    refTransactionId:
      isFollowUp && item?.transaction_id ? item?.transaction_id : null,
    isFollowUpReq: isFollowUp,
    prv_transaction_id: item && !isFollowUp && id ? id : "",
    is_edit_request: item && !isFollowUp ? true : false,
    isNewBorn: item?.is_new_born ? item?.is_new_born : false,
    isReferral: item?.is_referral ? item?.is_referral : false,
    isReferralIn:
      item?.is_referral_in ? item?.is_referral_in : false,
    patientId: item?.patient?.id ? item?.patient?.id : null,
    patientName: item?.patient?.full_name ? item?.patient?.full_name : null,
    patientDocumentId: item?.patient?.document_id
      ? item?.patient?.document_id
      : item?.patient_document_id || "",
    patientDob: item?.patient?.dob ? item?.patient?.dob : "",
    patientGender: item?.patient?.gender ? item?.patient?.gender : "",
    subscriberName: item?.patient?.full_name ? item?.patient?.full_name : null,
    insurancePlanId: item?.insurance_plan_id ? item?.insurance_plan_id : null,
    memberCardId: item?.insurance_plan?.member_card_id
      ? item?.insurance_plan?.member_card_id
      : "",
    subscriber: item?.subscriber_id ? item?.subscriber_id : null,
    payerId: item?.payer_id ? item?.payer_id : null,
    payerName: item?.payer_name
      ? item?.payer_name
      : item?.insurance_plan?.payer?.name_en || "",
    payerLicenseId: item?.insurance_plan?.payer?.license_id
      ? item?.insurance_plan?.payer?.license_id
      : "",
    payerTpaId: item?.insurance_plan?.payer?.tpa_id
      ? item?.insurance_plan?.payer?.tpa_id
      : "",
    dateOrdered: item?.date_ordered
      ? new Date(item?.date_ordered).toISOString().substring(0, 10)
      : currentDate.toISOString().substring(0, 10),
    claimType: item?.type ? item?.type : "",
    subType: item?.subtype ? item?.subtype : "",
    eligibilityResponseIdentifierValue: item?.verification_resp_ident_value
      ? item?.verification_resp_ident_value
      : "",
    eligibilityResponseIdentifierUrl: item?.verification_resp_ident_url
      ? item?.verification_resp_ident_url
      : "",
    offlineEligibilityId: item?.offline_verification_id
      ? item?.offline_verification_id
      : "",
    offlineEligibilityDate: item?.offline_verification_date
      ? item?.offline_verification_date
      : "",
    priority: item?.priority ? item?.priority : "stat",
    payeeType: "Provider",
    payee: "",
    relatedPreAuthRefNo: item?.related_pre_auth_ref_no
      ? item?.related_pre_auth_ref_no
      : "",
    preAuthRefNo: item?.pre_auth_ref_no ? item?.pre_auth_ref_no : "",
    offlinePreAuthNo: item?.offline_pre_auth_no ? item?.offline_pre_auth_no : "",
    offlinePreAuthDate: item?.offline_pre_auth_date ? item?.offline_pre_auth_date : "",
    referringProvider: "",
    //care Teams
    careTeamsArr: item?.care_teams
      ? item?.care_teams.map((el, index) => {
        return {
          practitioner: el.physician_id,
          practitionerName: el.name,
          practitioner_role: el.practitioner_role,
          care_team_role: el.care_team_role,
          qualification: el.speciality,
        };
      })
      : [],
    //diagnosis
    diagnosisArr: item?.diagnosis
      ? item?.diagnosis.map((el, index) => {
        return {
          id: index + 1,
          codeDescription: el.description,
          type: el.type,
          on_admission: el?.on_admission || false,
          codeId: el.code,
          condition_on_set: el?.condition_on_set || null,
        };
      })
      : [],
    //supporting Info
    supportingInfos: item?.supporting_info
      ? item?.supporting_info.map((el, index) => {
        return setSupportingInfo({
          ...el,
          valueUnit: el.unit,
          fileName: el?.image_title,
          fileType: el?.image_content_type,
          attachment: el?.image_value,
          imageMinioPath: el?.image_minio_path,
          imageUrl: el?.image_url,
          codeText: el?.code_text,
          endDate: el?.end_date,
          startDate: el?.start_date,
        });
      })
      : [],
    //accident info
    accident_type: "",
    street: "",
    city: "",
    state: "",
    country: "",
    date: "",
    is_accident: false,
    //items
    items: item?.items
      ? item?.items.map((el, index) => {
        return {
          type: el.type,
          standardCode: el.standard_code,
          standardCodeDescription: el.standard_description,
          non_standard_code: el.non_standard_code,
          non_standard_description: el.non_standard_description,
          body_site: el.body_site,
          sub_site: el.sub_site,
          service_start_date: el.service_start_date,
          service_end_date: el.service_end_date,
          //not getting this info in response
          supporting_info: el.supporting_info,
          diagnosis: el.diagnosis,
          care_teams: el.care_teams,
          //
          is_package: el.is_package,
          quantity: el.quantity,
          unit_price: el.unit_price,
          tax_amount: el.tax_amount,
          factor: el.factor,
          net: el.net,
          discount_amount: el.discount_amount,
          patient_share: el.patient_share,
          //not getting this info in response
          patientShareAmount: "",
          payer_share: "",
          medicationSelectionReason: el.medication_selection_reason,
          prescribedMedication: el.prescribed_medication,
          maternity: el.maternity,
          //
        };
      })
      : [],
    //vision prescription
    visionPrescriptionDateWritten: item?.vision_prescription_data?.date_written
      ? item?.vision_prescription_data?.date_written
      : null,
    lens_specifications: item?.vision_prescription_data?.lens_specifications
      ? item?.vision_prescription_data?.lens_specifications?.map(
        (item, index) => {
          return {
            product: item?.product ? item?.product : "",
            color: item?.color ? item?.color : "",
            brand: item?.brand ? item?.brand : "",
            notes: item?.notes ? item?.notes : "",
            rightSphere: item?.right?.sphere ? item?.right?.sphere : "",
            rightCylinder: item?.right?.cylinder ? item?.right?.cylinder : "",
            rightAxis: item?.right?.axis ? item?.right?.axis : "",
            rightAdd: item?.right?.add ? item?.right?.add : "",
            rightPrismUnit: item?.right?.prism?.base
              ? item?.right?.prism?.base
              : "",
            rightPrismVal: item?.right?.prism?.amount
              ? item?.right?.prism?.amount
              : "",
            rightPowerContact: item?.right?.power ? item?.right?.power : "",
            rightBackCurveContact: item?.right?.back_curve
              ? item?.right?.back_curve
              : "",
            rightDiameterContact: item?.right?.diameter
              ? item?.right?.diameter
              : "",
            rightUnitContact: item?.right?.duration?.time
              ? item?.right?.duration?.time
              : "",
            rightDurationContact: item?.right?.duration?.value
              ? item?.right?.duration?.value
              : "",
            leftSphere: item?.left?.sphere ? item?.left?.sphere : "",
            leftCylinder: item?.left?.cylinder ? item?.left?.cylinder : "",
            leftAxis: item?.left?.axis ? item?.left?.axis : "",
            leftAdd: item?.left?.add ? item?.left?.add : "",
            leftPrismUnit: item?.left?.prism?.base
              ? item?.left?.prism?.base
              : "",
            leftPrismVal: item?.left?.prism?.amount
              ? item?.left?.prism?.amount
              : "",
            leftPowerContact: item?.left?.power ? item?.left?.power : "",
            leftBackCurveContact: item?.left?.back_curve
              ? item?.left?.back_curve
              : "",
            leftDiameterContact: item?.left?.diameter
              ? item?.left?.diameter
              : "",
            leftUnitContact: item?.left?.duration?.time
              ? item?.left?.duration?.time
              : "",
            leftDurationContact: item?.left?.duration?.value
              ? item?.left?.duration?.value
              : "",
          };
        },
      )
      : [],
    prescriber_id: item?.vision_prescription_data?.prescriber_id
      ? item?.vision_prescription_data?.prescriber_id
      : null,
    isVisionPrescription: item?.vision_prescription_data ? true : false,
    //encounter fields
    isEncounter: false,
    encounterStatus: item?.encounter?.status
      ? item?.encounter?.status
      : "planned",
    encounterClass: item?.encounter?.class ? item?.encounter?.class : null,
    serviceType: item?.encounter?.service_type
      ? item?.encounter?.service_type
      : "acute-care",
    serviceEventType: item?.encounter?.service_event_type
      ? item?.encounter?.service_event_type
      : null,
    encounterPriority: item?.encounter?.priority
      ? item?.encounter?.priority
      : "EL",
    periodStart: item?.encounter?.period_start
      ? item?.encounter?.period_start
      : new Date().toISOString().split("T")[0],
    periodEnd: item?.encounter?.period_end ? item?.encounter?.period_end : null,
    adminSource: item?.encounter?.admin_source
      ? item?.encounter?.admin_source
      : null,
    readmission: item?.encounter?.readmission
      ? item?.encounter?.readmission
      : null,
    dischargeDisposition: item?.encounter?.discharge_disposition
      ? item?.encounter?.discharge_disposition
      : null,
    emergencyArivalCode: item?.encounter?.emr_arrival_code
      ? item?.encounter?.emr_arrival_code
      : null,
    emergencyServiceDate: item?.encounter?.emr_service_start
      ? item?.encounter?.emr_service_start
      : null,
    emergencyDepartmentDisposition: item?.encounter?.emr_dept_disp
      ? item?.encounter?.emr_dept_disp
      : null,
    triageCategory: item?.encounter?.triage_category
      ? item?.encounter?.triage_category
      : null,
    triageDate: item?.encounter?.triage_date
      ? item?.encounter?.triage_date
      : null,
    admissionSpeciality: item?.encounter?.hosp_adm_speciality
      ? item?.encounter?.hosp_adm_speciality
      : null,
    dischargeSpeciality: item?.encounter?.hosp_discharge_speciality
      ? item?.encounter?.hosp_discharge_speciality
      : null,
    intendedLengthOfStay: item?.encounter?.intended_length_of_stay
      ? item?.encounter?.intended_length_of_stay
      : null,
  };

  const addData = (values) => {
    setShowLoader(true);
    const input = formatInputData(values);

    requestPreAuth({
      variables: {
        // input: replaceEmptyStringWithNull(formatInputData(postData)), //temp
        input,
      },
    });

  };

  return (
    <>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        enableReinitialize={true}
        validate={(values) => {
          const errors = {};
        }}
        onSubmit={(values, { setSubmitting }) => {
          addData(values);
        }}
        validationSchema={preAuthValidationSchema(t)}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          /* and other goodies */
        }) => {
          return (
            <>
              <div className="pre_auth_req_page">
                <div className="bg-white border rounded-lg !p-3 !mb-2">
                  <BeneficiaryInfo
                    title={t("PreAuth Req. Form")}
                    setSelectedPatient={setSelectedPatient}
                    selectedPatient={selectedPatient}
                  />
                </div>

                <ValidationErrors validationErrors={item?.validation_errors} />

                <PreAuthInfo />

                <div className="!grid !grid-cols-1 lg:!grid-cols-2 gap-2">
                  <CareTeam />
                  <Diagnosis selectedPatient={selectedPatient} />
                </div>

                <SupportingInfoForm />

                {/* <IsAccident />
                {values.claimType == "vision" && <VisionPrescription />}
                <EncounterForm /> */}
                <ItemsList />

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                  <IsAccident />
                  <EncounterForm />
                </div>
                {values.claimType == "vision" && <VisionPrescription />}

                <div>
                  <div className="flex justify-center">
                    <CustomButton
                      onClick={handleSubmit}
                      icon={<CheckOutlinedIcon />}
                      isLoading={showLoader}
                      label={
                        item
                          ? isFollowUp
                            ? t("Follow Up Pre Auth Request")
                            : t("Update Pre Auth Request")
                          : t("Request Pre Auth")
                      }
                    />
                  </div>
                </div>
              </div>
              <AppErrorAlert data={errorData} />
              {/* <AppLoader showLoader={showLoader} setShowLoader={setShowLoader} /> */}
              <PreAuthResponseModal
                showPreAuthResponseModal={showPreAuthResponseModal}
                setShowPreAuthResponseModal={setShowPreAuthResponseModal}
                currentItem={currentTransactionIdItem}
              />
            </>
          );
        }}
      </Formik>
    </>
  );
}

export default PreAuthForm;
